import Customer                 from "../../../domain/customer/Customer";
import CustomerBirthDate        from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthday         from "../../../domain/customer/CustomerBirthday";
import CustomerBirthMonth       from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear        from "../../../domain/customer/CustomerBirthYear";
import CustomerContact          from "../../../domain/customer/CustomerContact";
import CustomerDetail           from "../../../domain/customer/CustomerDetail";
import CustomerId               from "../../../domain/customer/CustomerId";
import CustomerNumber           from "../../../domain/customer/CustomerNumber";
import Address                  from "../../../domain/fundamentals/address/Address";
import Building                 from "../../../domain/fundamentals/address/Building";
import City                     from "../../../domain/fundamentals/address/City";
import PostalCode               from "../../../domain/fundamentals/address/PostalCode";
import Prefecture               from "../../../domain/fundamentals/address/Prefecture";
import Street                   from "../../../domain/fundamentals/address/Street";
import Email                    from "../../../domain/fundamentals/email/Email";
import FirstName                from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana            from "../../../domain/fundamentals/name/FirstNameKana";
import LastName                 from "../../../domain/fundamentals/name/LastName";
import LastNameKana             from "../../../domain/fundamentals/name/LastNameKana";
import Name                     from "../../../domain/fundamentals/name/Name";
import Phone                    from "../../../domain/fundamentals/phone/Phone";
import { CustomerResponseType } from "../../api/customer/CustomerResponseType";
import { toGenderType }         from "../fundamentals";

export const toCustomer = (source: CustomerResponseType): Customer => new Customer(
  new CustomerId(source.id),
  new CustomerDetail(
    new CustomerNumber(source.detail.number),
    new Name(
      new LastName(source.detail.last_name),
      new FirstName(source.detail.first_name),
      new LastNameKana(source.detail.last_name_kana),
      new FirstNameKana(source.detail.first_name_kana),
    ),
    toGenderType(source.detail.gender_type)
  ),
  new CustomerBirthday(
    new CustomerBirthYear(source.birthday.year),
    new CustomerBirthMonth(source.birthday.month),
    new CustomerBirthDate(source.birthday.date),
  ),
  new CustomerContact(
    new Phone(source.contact.phone_number),
    new Email(source.contact.email),
  ),
  new Address(
    new PostalCode(source.address.postal_code),
    new Prefecture(source.address.prefecture),
    new City(source.address.city),
    new Street(source.address.street),
    new Building(source.address.building)
  ),
);
